import UST from '../assets/images/investments/ust2.png';
import TIME from '../assets/images/investments/time5.png';
import STRONG from '../assets/images/investments/strong.png';
import HEC from '../assets/images/investments/hec.jpg';
import POLYGON from '../assets/images/investments/matic.png';
import FTM from '../assets/images/investments/ftm.png';
import OHM from '../assets/images/investments/ohm.jpg';
import DAG from '../assets/images/investments/dag.jpg';
import TOMB from '../assets/images/investments/tomb.jpg';
import QNT from '../assets/images/investments/qnt.jpg';

export const investments = [
  {
    id: 11585,
    icon: TIME,
    coin: 'TIME',
    protocol: 'Wonderland',
    initialValue: 4346.5,
    investmentAmount: 100000,
    slug: 'wonderland',
  },
  {
    icon: STRONG,
    coin: 'STRNGR',
    protocol: 'Stronger',
    initialValue: 454.5,
    investmentAmount: 150000,
    slug: 'stronger',
    id: 19423,
  },
  {
    icon: UST,
    coin: 'UST',
    protocol: 'Terra',
    initialValue: 1,
    investmentAmount: 194000,
    slug: 'terrausd',
    id: 7129,
  },
  {
    icon: HEC,
    coin: 'HEC',
    protocol: 'Hector DAO',
    initialValue: 64.31,
    investmentAmount: 250000,
    slug: 'hector-dao',
    id: 13881,
  },
  {
    icon: POLYGON,
    protocol: 'Polygon',
    coin: 'MATIC',
    initialValue: 2.61,
    investmentAmount: 343849.1,
    slug: 'polygon',
    id: 3890,
  },
  {
    icon: FTM,
    coin: 'FTM',
    protocol: 'Fantom fWallet',
    initialValue: 2.78,
    investmentAmount: 150000,
    slug: 'fantom',
    id: 3513,
  },
  {
    icon: OHM,
    protocol: 'Olympus',
    coin: 'OHM',
    initialValue: 255.5,
    investmentAmount: 190245,
    slug: 'olympus',
    id: 9067,
  },
  // {
  //   protocol: ""
  //   coin: "LUNA",
  //   initialValue: 85.69,
  //   investmentAmount: 289003,
  // },
  {
    icon: DAG,
    protocol: 'Constellation',
    coin: 'DAG',
    initialValue: 0.185,
    investmentAmount: 250000,
    slug: 'constellation',
    id: 2868,
  },
  {
    icon: TOMB,
    protocol: 'Reaper Farm',
    coin: 'TOMB',
    initialValue: 2.82,
    investmentAmount: 300000,
    slug: 'tomb',
    id: 11495,
  },
  {
    icon: QNT,
    protocol: 'Quant',
    coin: 'QNT',
    initialValue: 119.02,
    investmentAmount: 250000,
    slug: 'quant',
    id: 3155,
  },
];

export const InitialOptions = {
  grid: {
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
    row: {
      colors: undefined,
      opacity: 0.5,
    },
    padding: {
      top: 0,
      bottom: 0,
    },
  },
  chart: {
    height: 100,
    toolbar: {
      show: false,
    },
    sparkline: {
      enabled: true,
    },
    type: 'line',
  },

  stroke: {
    width: 5,
    curve: 'smooth',
  },

  xaxis: {
    categories: new Array(25).fill().map((i, index) => {
      if (index < 23) return `${24 - index} hours ago`;
      if (index === 23) return `${24 - index} hour ago`;
      return `Now`;
    }),
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: false,
    },
  },
  annotations: {
    points: [
      {
        x: 272,
        y: 0,
        marker: {
          size: 2,
          colors: '#ffffff',
          strokeColor: '#ffffff',
          // strokeOpacity: 0.1,
          // strokeWidth: 8
        },
      },
    ],
  },
  fill: {
    type: 'gradient',
    // colors: ["#4B24DC"],
    gradient: {
      shade: 'light',
      // gradientToColors: ["#ECB533"],
      shadeIntensity: 1,
      type: 'horizontal',
      opacityFrom: 0,
      opacityTo: 1,
      // colorStops: [
      //   {
      //     offset: 0,
      //     color: "#4B24DC",
      //     opacity: 0.1,
      //   },
      //   {
      //     offset: 100,
      //     color: "#48BB78",
      //     opacity: 1,
      //   },
      // ],
    },
  },
  yaxis: {
    show: false,
    labels: {
      show: false,
    },
  },
  tooltip: {
    y: {},
  },
};

export const TOKEN_CONTRACT = '0x8F47416CaE600bccF9530E9F3aeaA06bdD1Caa79';
export const BIFROST_CONTRACT = '0x968171f68DBc9137CF26256A9c87db763E8A1bE2';


export const TIER_CONTRACTS = {
  THOR: '0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79',
  AVAX: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
  FREYA: '0x79190a9c108F6cc1CE956eA8f7ba03cD4e3260b9',
  ODIN: '0x9C0200F3e9673BCfe6D80076aa976F446d74758A',
  HEIMDALL: '0xbA4400C4619Cd15267c2FeCd4Dbc39d310CEe3f1',
};

export const TIER_MANAGER_CONTRACTS = {
  THOR: '0x37DA69aa9b436D3Bf6cC7530E11Ef98A5a052441',
  FREYA: '0x79190a9c108F6cc1CE956eA8f7ba03cD4e3260b9',
  ODIN: '0x9C0200F3e9673BCfe6D80076aa976F446d74758A',
  HEIMDALL: '0xbA4400C4619Cd15267c2FeCd4Dbc39d310CEe3f1'
}

export const MASTER_OF_COIN = "0x9aD4dF248019A36b29202aEC91a1b9aAA863341a";
// '0x0d8c4C9A47A6eb59e3983Ee69CC1Fd4907554cb2';
